import PubNub from "pubnub";

class PubNubService {
  pubnub: PubNub | null = null;

  init(userId: string) {
    this.pubnub = new PubNub({
      publishKey: "pub-c-11f495b3-e016-4875-98f4-66620ede30fd",
      subscribeKey: "sub-c-e8fe25e6-d569-11e9-bcc0-82128b712eba",
      uuid: userId,
    });
  }

  subscribe(channels: string[]) {
    if (!this.pubnub) return;
    this.pubnub.subscribe({ channels });
  }

  addListener(callbacks: {
    status?: (statusEvent: unknown) => void;
    message?: (msg: unknown) => void;
    presence?: (pres: unknown) => void;
  }) {
    if (!this.pubnub) return;

    this.pubnub.addListener({
      status: (statusEvent: unknown) => {
        // PubNub status event - handled by callbacks
        if (callbacks?.status) callbacks.status(statusEvent);
      },

      message: (msg: unknown) => {
        if (callbacks?.message) callbacks.message(msg);
      },

      presence: (pres: unknown) => {
        if (callbacks?.presence) callbacks.presence(pres);
      }
    });
  }
}

export const pubnubService = new PubNubService();
